import React from "react";

const HowWeDo = () => {
  return (
    <section id="how" className="py-12 md:py-20 bg-white/[0.015] border-y border-white/5">
      <div className="w-[90%] max-w-[1000px] mx-auto">
        <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl md:text-5xl">
          Full Stack <span className="text-gold-gradient">Coaching</span>
        </h2>

        <div className="mt-8 space-y-6 text-lg md:text-xl text-white/75 leading-relaxed font-medium max-w-3xl">
          <p>
            Everyone's been selling you a piece of it. The hormone clinic says it's your hormones.
            The nutritionist says it's your diet. The wellness and weight-loss clinic say it's a
            prescription. They're all partly right, and that's exactly the problem: not one of
            them can fix this alone.
          </p>
          <p>
            Here's the uncomfortable truth: if you could only pick one, you'd be better off hiring
            a good personal trainer. Training, nutrition, recovery and cardiovascular activity
            covers more of what's wrong with you than any single clinic or provider does. But
            "better than the other options" isn't the same as problems solved.
          </p>
          <p className="font-display font-black uppercase tracking-tight leading-tight text-xl sm:text-2xl md:text-[1.75rem] !mt-8 !mb-8" style={{ color: "#D4AF35" }} data-testid="full-stack-tagline">
            Stop wasting time and money on plans that quit working after 40.
          </p>
          <p className="text-white font-bold">
            That gap is why Full Stack Coaching exists.
          </p>
          <p>
            One health and fitness coach who owns all seven systems: training, nutrition, gut
            health, cardiovascular activity and recovery in-house, plus labs, hormone and metabolic
            support available through our vetted medical, lab and pharmacy partners whenever you're
            ready for them.
          </p>
          <p>
            One evidence-based, personalized plan built in the order your body needs, monitored
            and adjusted as you go. Everything coordinated for you, so nothing falls through the
            cracks.
          </p>
          <p className="text-white font-bold">
            One dedicated expert partner, with you every step of the way.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowWeDo;
